import {emptyOrNull} from "@/utils/common";
import {checkSuccess, getAllSchoolForManager} from "@/api/Apis";
import store from "@/store/index";
import storage from "@/utils/storage";

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  schools: state => {
    if (emptyOrNull(state.app.schools)) {
      //先使用缓存的
      getAllSchoolForManager().then(res=>{
        if(checkSuccess(res)){
          let schools = res.data.data.schools;
          store.commit('SET_SCHOOLS', schools);
          store.commit('SET_SCHOOL_ID',schools.length > 0 ? schools[0].id:null)
        }
      })
      //先临时使用 storage里面的
      return storage.get("schools2");
    }

    return state.app.schools
  },
  school:state => state.app.school,
  schoolId: state => {
    if(emptyOrNull(state.app.schools)){
      getAllSchoolForManager().then(res=>{
        if(checkSuccess(res)){
          let schools = res.data.data.schools;
          store.commit('SET_SCHOOLS', schools);
          store.commit('SET_SCHOOL_ID',schools.length > 0 ? schools[0].id:null)
        }
      })
    }else if(!state.app.cur_school_id && state.app.schools.length > 0){

      store.commit('SET_SCHOOL_ID',state.app.schools[0].id)
      return state.app.schools[0].id
    }
    return state.app.cur_school_id
  },
  cur_school_id: state => state.app.cur_school_id,
  teacherId:state => state.app.teacherId,
  teachers:state => state.app.teachers,
  teachersBySchool:state => state.app.teachersBySchool,
  month:state => state.app.month,
  permission_routes: (state) => {
    return state.permission.routes
  },
  isSystemManager: (state) => {
    return state.permission.isSystemManager
  },
  devMode: (state) => {
    return state.permission.devMode
  },
  sideBarItems: state => {
    if(!state.permission.sideBarItems) return []
    return state.permission.sideBarItems
  },
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js